module.exports = __webpack_public_path__ + "4b6c8c88840b3204ba993360a90ddbbc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/princeton_university_2_2023_chart.png
// module id = 1720
// module chunks = 0